/* SpokeX — Duplicate Product JSON-LD deduper
   Removes legacy http://schema.org Product blocks emitted by 3rd-party apps.
   Keeps the SpokeX snippet's https://schema.org Product block intact.
   Runs on DOMContentLoaded + 1s + 5s to catch late-injected app scripts. */

(function () {
  'use strict';

  var runs = 0;
  var MAX_RUNS = 3;
  var TIMEOUTS = [0, 1000, 5000];

  function dedupe() {
    runs += 1;
    if (runs > MAX_RUNS) return;

    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    if (scripts.length < 2) return;

    var kept = 0;
    var removed = 0;

    scripts.forEach(function (script) {
      var raw = script.textContent.trim();
      if (!raw) return;

      var data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        return;
      }

      if (!data || typeof data !== 'object') return;

      // Normalize: some apps wrap in @graph
      var items = Array.isArray(data['@graph']) ? data['@graph'] : [data];

      // Identify legacy Product blocks (http://, plain-string brand, ugly description)
      var isLegacyProduct =
        data['@type'] === 'Product' &&
        data['@context'] === 'http://schema.org';

      if (isLegacyProduct) {
        script.parentNode && script.parentNode.removeChild(script);
        removed += 1;
        return;
      }

      // Check inside @graph too
      if (Array.isArray(data['@graph'])) {
        var hasLegacyProduct = items.some(function (item) {
          return (
            item &&
            item['@type'] === 'Product' &&
            item['@context'] === 'http://schema.org'
          );
        });
        if (hasLegacyProduct && data['@graph'].length === 1) {
          // Single-item @graph that IS a legacy Product — remove whole block
          script.parentNode && script.parentNode.removeChild(script);
          removed += 1;
          return;
        }
        // Mixed @graph: leave alone (too risky to surgically extract)
      }

      kept += 1;
    });

    if (removed > 0) {
      console.info(
        '[spx-dedup-schema] removed ' +
          removed +
          ' legacy Product JSON-LD block(s), kept ' +
          kept
      );
    }
  }

  TIMEOUTS.forEach(function (ms) {
    setTimeout(dedupe, ms);
  });
})();